/**
 * El reporte de salud, para verlo sin backend. Proyectos inventados en las
 * unidades de PROD —Business Solutions con SAP y Odoo, Product Factory y
 * Marketing— y en tres sociedades, con uno sano, uno en atención, uno en
 * riesgo y uno sin facturar. Respeta el rango pedido.
 */
const PROYECTOS = [
  { id: 1, codigo: 'SFOIC1', cliente: 'ITEM', nombre: 'Implementación Odoo - ITEM', unidad: 'Business Solutions', linea: 'Odoo', producto: 'Odoo', sociedad_id: 1, sociedad: 'Vippinn Argentina', margen: 0.42 },
  { id: 5, codigo: 'SFOWG2', cliente: 'Warc Group', nombre: 'Implementación Odoo - Warc Group', unidad: 'Business Solutions', linea: 'Odoo', producto: 'Odoo', sociedad_id: 4, sociedad: 'Vippinn U.S.A.', margen: 0.35 },
  { id: 2, codigo: 'SFSTR3', cliente: 'Stratesys', nombre: 'Consultores SAP', unidad: 'Business Solutions', linea: 'SAP', producto: 'Talent Hub BS', sociedad_id: 2, sociedad: 'Vippinn Chile', margen: 0.27 },
  { id: 3, codigo: 'SFDEF2', cliente: 'Defensoría', nombre: 'Monitor de Derechos', unidad: 'Product Factory', linea: null, producto: 'Productos Digitales', sociedad_id: 1, sociedad: 'Vippinn Argentina', margen: 0.12 },
  { id: 4, codigo: 'SFRITE', cliente: 'RITE', nombre: 'Mantenimiento de Sistema RITE', unidad: 'Product Factory', linea: null, producto: 'Productos Digitales', sociedad_id: 1, sociedad: 'Vippinn Argentina', margen: null },
  { id: 6, codigo: 'MKCAM1', cliente: 'Grupo Corven', nombre: 'Campaña digital', unidad: 'Marketing', linea: null, producto: 'Marketing', sociedad_id: 5, sociedad: 'Vippinn Marketing', margen: 0.31 }
];

function sumar(mes: string, n: number): string {
  const [a, m] = mes.split('-').map(Number);
  const d = new Date(a, m - 1 + n, 1);

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function respuestaSalud(ruta: string, params: URLSearchParams | null): unknown | null {
  // Quién cargó horas en un proyecto: solo horas, nunca tasas
  if (/\/api\/reportes\/salud\/proyecto\/\d+\/personas$/.test(ruta)) {
    const meses = (params?.get('meses') ?? '').split(',').filter(Boolean).length || 1;
    const gente = ['Julio César Alarcón', 'Maximiliano Belgrado', 'Agustín Massaferro', 'Otto Diebel', 'Cecilia Lingua'];

    const tickets = [['-43', 'Nominal', 488, 3], ['-36', 'GLPI 146710', 216, 2], ['-42', 'Pluspetrol 30781', 198, 4], ['-45', null, 80, 1]];

    return {
      success: true,
      personas: gente.map((nombre, i) => ({ nombre, horas: (176 - i * 30) * meses })),
      tickets: tickets.map(([k, titulo, horas, personas]) => ({ ticket: `PRY${k}`, titulo, horas, personas }))
    };
  }

  if (!/\/api\/reportes\/salud\/?$/.test(ruta)) {
    return null;
  }

  const hoy = new Date();
  const actual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
  const primero = `${hoy.getFullYear()}-01`;
  const desde = [params?.get('desde') ?? primero, primero].sort()[1];
  const hasta = params?.get('hasta') ?? actual;
  const meses: string[] = [];

  for (let m = desde; m <= hasta; m = sumar(m, 1)) meses.push(m);

  const filas: unknown[] = [];

  PROYECTOS.forEach((p, k) => {
    meses.forEach((mes, i) => {
      const horas = 110 + ((i * 37 + k * 53) % 90);
      const costo = horas * (14 + k * 2);
      const facturado = p.margen === null ? 0 : costo / (1 - p.margen) * (0.85 + ((i + k) % 4) * 0.1);

      filas.push({
        proyecto_id: p.id, mes,
        facturado: Math.round(facturado),
        horas_facturadas: p.margen === null ? 0 : Math.round(horas * 0.9),
        horas_producidas: horas,
        costo_horas: Math.round(costo)
      });
    });
  });

  return {
    success: true,
    moneda: 'USD',
    sin_cotizacion: false,
    // Los dos últimos meses siguen abiertos
    meses: meses.map((mes) => ({ mes, cerrado: mes < sumar(actual, -1) })),
    primer_mes_con_horas: meses[0] ?? null,
    primer_mes_con_datos: primero,
    proyectos: PROYECTOS.map(({ margen, ...p }) => ({ ...p, estado: 'En Curso' })),
    filas,
    umbrales: { verde: 30, amarillo: 25 }
  };
}
